/**
 * Campaign Routes
 * Admin back-office for fundraising campaigns (list + builder/detail).
 * The public sponsor page is registered separately in auth.routes.tsx.
 */

import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AppShell } from "@/components/layout/AppShell";
import { LazyPage } from "../helpers";

const CampaignsListPage = lazy(
  () => import("@/pages/campaigns/CampaignsListPage"),
);
const CampaignDetailPage = lazy(
  () => import("@/pages/campaigns/CampaignDetailPage"),
);

const MANAGER_ROLES = ["super_user", "admin", "principal"];

export const campaignRoutes: RouteObject[] = [
  {
    path: "/campaigns",
    element: (
      <ProtectedRoute roles={MANAGER_ROLES}>
        <AppShell>
          <LazyPage>
            <CampaignsListPage />
          </LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
  {
    path: "/campaigns/:id",
    element: (
      <ProtectedRoute roles={MANAGER_ROLES}>
        <AppShell>
          <LazyPage>
            <CampaignDetailPage />
          </LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
];
